var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "headline" }, [
                _vm._v("Level Config (" + _vm._s(this.rules.name) + ")"),
              ]),
              _c("v-spacer"),
              _c("v-switch", {
                staticClass: "mb-5",
                attrs: {
                  label: "Enabled",
                  color: "success",
                  "hide-details": "",
                },
                model: {
                  value: _vm.model.enabled,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "enabled", $$v)
                  },
                  expression: "model.enabled",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "resizable-card__body" },
            [
              _c(
                "v-col",
                { attrs: { cols: "4", sm: "2", md: "2" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.showPreview()
                        },
                      },
                    },
                    [_vm._v("View JSON")]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-3", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "3", sm: "3" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Level Id:", "hide-details": "" },
                        model: {
                          value: _vm.model.level,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "level", _vm._n($$v))
                          },
                          expression: "model.level",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "3", sm: "3" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Energy capacity:",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.model.energyCapacity,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "energyCapacity", _vm._n($$v))
                          },
                          expression: "model.energyCapacity",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("r-range", {
                        attrs: {
                          model: _vm.model.experience,
                          label: "Experience:",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "experience", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-col", { attrs: { cols: "12" } }),
                  _c(
                    "v-expansion-panels",
                    [
                      _c("r-reward-panel", {
                        attrs: { model: _vm.model.reward, title: "Rewards" },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "reward", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "resizable-card__actions" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: { mousedown: _vm.startResize },
          }),
          _c("r-preview-dialog", { ref: "preview-dialog" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }